import { TextOverflowChainHandler } from 'assets/js/editor/factory/text-overflow/chainHandler';

const FormatFactory = require('../../../factory/formats');
const DesignFacade = require('../../design/design');
const EditorFacade = require('../../editor/editor');
const CompanyFactory = require('../../../factory/company').instance;
const { getQueryParameter } = require('../../../../../../assets/js/helpers/dataUrl');
let domain, campaignId, companyId, templateId, url, referrer;

module.exports = _.extend({
  initialize: function () {
    _.bindAll(this, '_onAdd', 'add', '_onRemove', 'remove');

    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.chainHandler = new TextOverflowChainHandler();
    this.canvas = this.editor.canvas;
  },

  copy: async function (params) {
    if (!params) params = {};

    const designId = params.design_id ?? INKIVE.Tool._current_design_id;
    const hasTextOverflow = this.chainHandler.getLinkedTextElementsFromPage(designId)?.length;

    if (hasTextOverflow) {
      const proceedCopy = await new Promise(resolve => {
        INKIVE.EditorFacade.handle('confirm', 'show', {
          labels: {
            title: INKIVE.TranslateHelper.translate('text_overflow.linkage_issue.title'),
            description: INKIVE.TranslateHelper.translate('text_overflow.linkage_issue.duplicate_page_description'),
            confirmButton: INKIVE.TranslateHelper.translate('text_overflow.linkage_issue.duplicate_page'),
            cancelButton: INKIVE.TranslateHelper.translate('text_overflow.linkage_issue.cancel')
          },
          onConfirm: () => resolve(true),
          onCancel: () => resolve(false)
        });
      });

      if (!proceedCopy) return;
    }

    let design;
    const deferred = $.Deferred();
    const onCopied = _.bind(_onCopied, this);
    const needSave = typeof params.save === 'undefined'
      ? true
      : params.save;

    toggleAlerts(true);

    this._getDesignWithDesignId(params).then(function (d) {
      design = d;
      needSave && EditorFacade.handle('page', 'save').then(startCopy);
      needSave || startCopy();
    });

    return deferred.promise();

    function startCopy () {
      INKIVE.PageFactory.duplicatePage({
        based_on: design.design_id,
        append: params.append || false
      }).then(onCopied, onCopied);
    }

    function toggleAlerts (value) {
      if (!params.quiet) {
        INKIVE.Modal.toggleLock(value);
        INKIVE.Modal.togglePageLoader(value);
      }
    }

    async function _onCopied (response) {
      const RestrictionsFactory = require('../../../factory/restrictions');
      const isRestrictedProject = INKIVE.RestrictionsFacade.isRestrictedProject();

      if (response && response.status === 'success') {
        INKIVE.C.BOOK.num_pages++;

        this.trigger('copied', {
          stay: params.stay,
          append: params.append,
          based_on: design.design_id,
          page_number: design.page_number,
          ...response
        });
        this.canvas.loadingElement(true);
        await EditorFacade.handle('header_and_footer', 'duplicate_page', {
          pageNumber: response.page_number,
          pageId: Number(response.design_id)
        });

        isRestrictedProject || allDone(response);
        isRestrictedProject && RestrictionsFactory
          .copyRestrictions(design.page_number).then(
            _.partial(allDone, response)
          );
      } else {
        toggleAlerts(false);

        INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
          message: 'modal.alert.copy',
          more_info: response.message
        }));
      }
    }

    function allDone (response) {
      toggleAlerts(false);
      deferred.resolve(response);
      EditorFacade.handle('page', 'move_to', {
        save: false,
        design_id: response.design_id
      });
    }
  },

  remove: async function (params) {
    if (!params) params = {};

    const designId = params.design_id ?? INKIVE.Tool._current_design_id;
    const hasTextOverflow = this.chainHandler.getLinkedTextElementsFromPage(designId)?.length;

    if (hasTextOverflow) {
      const proceedRemove = await new Promise(resolve => {
        INKIVE.EditorFacade.handle('confirm', 'show', {
          labels: {
            title: INKIVE.TranslateHelper.translate('text_overflow.linkage_issue.title'),
            description: INKIVE.TranslateHelper.translate('text_overflow.linkage_issue.remove_page_description'),
            confirmButton: INKIVE.TranslateHelper.translate('text_overflow.linkage_issue.remove_page'),
            cancelButton: INKIVE.TranslateHelper.translate('text_overflow.linkage_issue.cancel')
          },
          onConfirm: () => resolve(true),
          onCancel: () => resolve(false)
        });
      });

      if (!proceedRemove) return;
    }

    const deferred = $.Deferred();

    this._getDesignWithDesignId(params).then(_.bind(function (design) {
      if (!design) {
        console.warn('Design not found');
        return;
      }

      params.design_id = design.design_id;
      params.page_number = design.page_number;

      const onRemove = _.partial(this._onRemove, params, deferred);

      this.editor.canvas.clearSelection();

      params.quiet && proceeds();
      params.quiet || INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_span', {
        text: INKIVE.C.BOOK.num_pages === 1
          ? INKIVE.TranslateHelper.translate('modal.alert.can_delete_last')
          : INKIVE.TranslateHelper.translate('modal.alert.delete_page', {
            page_number: params.page_number,
            is_current_page: INKIVE.Tool._current_design_id === params.design_id
          })
      }), { callback: [proceeds, function () { deferred.reject(); }] });

      function proceeds () {
        if (INKIVE.C.BOOK.num_pages === 1) {
          INKIVE.FormatFactory.getCurrentFormat().then(function (format) {
            campaignId = format.campaign;
            CompanyFactory.getProjectData().then((projectData) => {
              domain = projectData.company.domain;
              companyId = projectData.company.id;
              templateId = projectData.id;
              referrer = getQueryParameter('referrer');
              url = referrer.includes('designs')
                ? `brand/companies/${companyId}/designs/${templateId}`
                : `brand/companies/${companyId}/campaigns/${campaignId}/templates/${templateId}`;
              INKIVE.DesygnerApi.delete(url).then(onRemove, onRemove);
            });
          });
        } else {
          INKIVE.PageFactory.deletePage(params.design_id)
            .then(onRemove)
            .catch(onRemove);
        }
      }
    }, this));

    return deferred.promise();
  },

  _getDesignWithDesignId: function (params) {
    let design; const deferred = $.Deferred();
    const ProjectFacade = require('../project');

    if (params.page_number) {
      ProjectFacade.get('design_id', { page_number: params.page_number }).then(function (designId) {
        design = ProjectFacade.get('design', { design_id: designId });
        deferred.resolve(design);
      });
    } else {
      const designId = params.design_id || INKIVE.Tool._current_design_id;
      design = ProjectFacade.get('design', { design_id: designId });

      design && deferred.resolve(design);
      design || ProjectFacade.refreshPageInfo().then(function () {
        design = ProjectFacade.get('design', { design_id: designId });
        deferred.resolve(design);
      });
    }

    return deferred.promise();
  },

  _onRemove: async function (params, deferred, result) {
    const resultObject = result?.json ? await result.json() : result;

    if (resultObject && (resultObject.status === 'success' || Object.keys(resultObject).length === 0)) {
      this.trigger('removing', params);

      await EditorFacade.handle('header_and_footer', 'delete_page', {
        pageId: Number(params.design_id),
        pageNumber: params.page_number
      });

      if (INKIVE.C.BOOK.num_pages === 1 && !INKIVE.C.IS_MOBILE_APP) {
        const isWebrand = BASE_URL.includes('//editor.');
        const replacePattern = isWebrand
          ? '//editor.'
          : '//';
        const redirectPage = referrer && referrer.includes('designs')
          ? 'create/designs'
          : 'create/templates';
        if (INKIVE.EditorModeManager.isMode('logo')) {
          window.location = BASE_URL + 'library';
        } else {
          window.location = domain !== 'desygner'
            ? BASE_URL.replace(replacePattern, `//${domain}.`) + redirectPage
            : BASE_URL + redirectPage;
        }
      } else {
        if (INKIVE.Tool._current_page_number === INKIVE.C.BOOK.num_pages) {
          INKIVE.Tool._current_page_number--;
        }
        INKIVE.C.BOOK.num_pages--;
        if (Number(INKIVE.Tool._current_design_id) === Number(params.design_id)) {
          EditorFacade.handle('page', 'unload', { remove_from_cache: true });
          EditorFacade.handle('page', 'move_to', {
            save: false,
            page_number: params.page_number > INKIVE.C.BOOK.num_pages
              ? params.page_number - 1
              : params.page_number
          }).then(_.bind(function () {
            deferred.resolve();
            this.trigger('removed', params);
          }, this));
        } else {
          deferred.resolve();
          this.trigger('removed', params);
        }
      }
    } else deferred.reject(new Error('Removing page failed'));
  },

  add: function (params) {
    const deferred = $.Deferred();
    const canvas = this.editor.canvas;

    params = _.extend({
      page_number: parseInt(INKIVE.C.BOOK.num_pages) + 1,
      size: Object.assign(FormatFactory.getCurrentSize(), {
        current_size: {
          width: canvas.contentW,
          height: canvas.contentH
        }
      })
    }, params);

    canvas.clearSelection();
    params.quiet || INKIVE.Modal.togglePageLoader(true);
    const editor = INKIVE.Tool.getInstance().editor;
    editor.loadingElement(true);

    INKIVE.PageFactory.createNewPage({
      width: params.size.width,
      height: params.size.height,
      unit: params.size.unit,
      page_number: params.page_number
    })
      .then(_.partial(this._onAdd, params, deferred));

    return deferred.promise();
  },

  _onAdd: async function (params, deferred, result) {
    const ProjectFacade = require('../project');

    params.quiet || INKIVE.Modal.togglePageLoader(false);

    if (result.status === 'success') {
      INKIVE.C.BOOK.num_pages++;

      const designs = _.map(ProjectFacade.get('designs'), 'design_id');
      const pageNumber = parseInt(result.page_number);
      const designId = String(result.design_id);
      result.design_id = designId;
      designs.splice(result.page_number - 1, 0, designId);
      await ProjectFacade.changePageOrder(designs);

      this.trigger('added', _.extend(result, params));

      await EditorFacade.handle('header_and_footer', 'create_page', {
        page_number: result.page_number,
        page_id: Number(result.design_id)
      });

      EditorFacade.handle('page', 'move_to', {
        page_is_empty: false,
        page_number: pageNumber,
        ...params
      }).then(_.debounce(async function () {
        const editor = INKIVE.Tool.getInstance().editor;
        editor.loadingElement(false);
        INKIVE.Tool._current_page_number = pageNumber;
        DesignFacade.set('template', { size: params.size });

        deferred.resolve();
      }, 0));
    } else deferred.reject(new Error('Adding page failed'));
  }
}, Backbone.Events);
